import type React from 'react';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();
  const { isAuthenticated, signinRedirect, isLoading: isAuthLoading } = auth;
  const { pathname, search } = useLocation();
  const [isCheckingPermissions, setIsCheckingPermissions] = useState(true);

  useEffect(() => {
    if (isAuthLoading) {
      return;
    }

    if (!isAuthenticated) {
      sessionStorage.setItem('authRedirectUrl', `${pathname}${search}`);
      signinRedirect();
      return;
    }

    setIsCheckingPermissions(false);
  }, [isAuthenticated, signinRedirect, isAuthLoading, pathname, auth]);

  if (isAuthLoading || isCheckingPermissions) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
